export const setWidgetInteractable = (state, widgetInteractable) => {
  return { widgetInteractable };
};
